/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'VideoListingBlock';
const CLS = 'videoListingBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/videoListingBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import _ from 'lodash';
import moment from 'moment';
import Handlebars from 'handlebars';

import * as Api from '../api';
import utils from '../utils';

export class VideoListingBlock {
	constructor($el) {
		// $el is the widget node return by the loadVideoListingBlock function
		this.$el = $el;
	}

	init() {
		const This = this;
		const $wg = $(this.$el);
		This.page = 0;
		This.loadingSpinner = $('.loading-spinner');
		This.videosList = $wg.find(`${WG}videosList ${WG}videosList--innerWrapper`);
		This.loadMore = $wg.find(`${WG}loadMore`);
		this.setVideoBlockItem();
		this.setVideoListingBlock();
	}

	setVideoListingBlock() {
		// Add Some logic here
		const This = this;
		const $wg = $(this.$el);

		// mark the first items in the dropdown menu as selected
		$wg.find('[data-key]').each(function() {
			$(this).find('.dropdown-item').first().addClass('is-selected');
		});

		$wg.on('click', `${WG}loadMore button`, function() {
			This.getVideos();
		});

		// get videos on load
		This.getVideos();

		$wg.on('click', '.dropdown-item', function(e) {
			let $this = $(this);

			// skip the click event if the selection hasn't changed
			if ($this.hasClass('is-selected')) {
				return;
			}

			// remove active classes
			// $wg.find(`${WG}filters--innerWrapper, ${WG}mobileFilterBtn`).removeClass('is-active');

			$this.closest('.dropdown').find('.dropdown-item').removeClass('is-selected');
			$this.addClass('is-selected');
			$this.closest('.dropdown').find('button').text($this.text());
			// get videos (emptying the list)
			This.getVideos(true);
		});

		$wg.on('click', `${WG}mobileFilterBtn`, function() {
			let filters = $wg.find(`${WG}filters--innerWrapper`);
			$(this).toggleClass('is-active');
			if ($(this).hasClass('is-active')) {
				filters.addClass('is-active');
			} else {
				filters.removeClass('is-active');
			}
		});

		$wg.on('click', `${WG}clear`, function() {
			// remove active classes
			$wg.find(`${WG}filters--innerWrapper, ${WG}mobileFilterBtn`).removeClass('is-active');
			// reset filters to the first dropdown in each group
			$wg.find('[data-key]').each(function() {
				$(this).find('.dropdown-item').removeClass('is-selected');
				$(this).find('.dropdown-item').first().addClass('is-selected');
				$(this).find('button').text($(this).find('.dropdown-item').first().text());
			});
			// get videos (emptying the list)
			This.getVideos(true);
		});

		$(window).on('resize', _.debounce(function() {
			let mobileFiltersBtn = $wg.find(`${WG}mobileFilterBtn`);
			let filters = $wg.find(`${WG}filters--innerWrapper`);
			if (!utils.isBelowMd()) {
				$wg.trigger('click'); // click away from the dropdowns
				mobileFiltersBtn.removeClass('is-active');
				filters.removeClass('is-active');
			}
		}, 150));
	}

	getVideos(clearList = false) {
		const This = this;
		const $wg = $(this.$el);

		if (clearList) {
			This.page = 0;
			This.videosList.empty();
		}

		// increment page
		This.page++;

		// show spinner
		This.loadingSpinner.addClass('is-active');

		This.getVideosCall().then(function(data) {
			let hasMore = data.hasMore;
			let videos = data.videos;
			if (videos.length > 0) {
				for (let i = 0; i < videos.length; i++) {
					let video = videos[i];
					// format date
					video.videoDate = moment(video.videoDate, 'DD-MM-YYYY').format('DD MMMM YYYY');
					// pass video object to hbs
					let videoBlockHtml = This.videoBlockItemTemplate(video);
					// append to the videos list
					This.videosList.append(videoBlockHtml);
				}
			} else {
				// no videos
				This.videosList.html(`
					<p>Sorry, no webinars were found.</p>
				`);
			}
			// check if hasMore
			if (hasMore) {
				This.loadMore.removeClass('d-none');
			} else {
				This.loadMore.addClass('d-none');
			}
			// remove loading spinner
			This.loadingSpinner.removeClass('is-active');
		}, function(err) {
			This.loadingSpinner.removeClass('is-active');
		});
	}

	getVideosCall() {
		const This = this;
		const $wg = $(this.$el);
		let endpoint = $wg.data('getVideosEndpoint');
		let extraParams = '';
		$wg.find('[data-key]').each(function() {
			let filter = $(this).data('key');
			let id = $(this).find('.dropdown-item.is-selected').data('id');
			extraParams = extraParams + `&${filter}=${id}`;
		});
		return Api.getApi(endpoint + `?pageSize=5&pageNum=${This.page}` + extraParams);
	}

	setVideoBlockItem() {
		const This = this;
		let partial = require('../../partials/widgets/videoListingItemBlock.hbs');
		Handlebars.registerPartial('videoListingItemBlock', partial);
		let template = `
			{{> videoListingItemBlock
				wg="videoListingItemBlock"
				ns="VideoListingItemBlock"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		This.videoBlockItemTemplate = Handlebars.template(precompiled);
	}

	// Add more functions like on above here
}
